import { BankAccountMainTypeEnum } from './type';

export const BankAccountMainTypeMap = {
    [BankAccountMainTypeEnum.Checking]: __('Checking'),
    [BankAccountMainTypeEnum.Savings]: __('Savings')
};
